function initWorkFieldToggles() {
  const workFieldsToggles = document.querySelectorAll('#work-fields');

  workFieldsToggles?.forEach(function (workFieldToggle) {
    workFieldToggle.addEventListener('click', function (e) {
      const workField = this.closest('.work-field');
      const preview = workField?.querySelector('.preview-pdf-block');
      const toggleCaptionShow = workField?.querySelector('.toggle-caption-show');
      const toggleCaptionHide = workField?.querySelector('.toggle-caption-hide');
      const toggleArrow = workField?.querySelector('.toggle_arrow');

      if (preview && preview.classList.contains('d-none')) {
        this.classList.add('show');
        toggleArrow.classList.add('show');
        preview.classList.remove('d-none');
        toggleCaptionShow.classList.add('d-none');
        toggleCaptionHide.classList.remove('d-none');
      } else {
        this.classList.remove('show');
        toggleArrow?.classList.remove('show');
        preview?.classList.add('d-none');
        toggleCaptionShow?.classList.remove('d-none');
        toggleCaptionHide?.classList.add('d-none');
      }
    });
  });
}

export default function() {
  initWorkFieldToggles()
}
